import { Button, Tooltip } from 'antd'
import { FaArrowDown } from 'react-icons/fa'

export default function DownloadImportTemplate() {
  const handleDownloadTemplate = () => {
    const link = document.createElement('a')
    link.href = '/formatos/importacion.xlsx'
    link.download = 'VIVA_FormatoImportacion.xlsx'
    link.click()
  }

  return (
    <Tooltip title='Descargar plantilla' placement='bottom'>
      <Button
        className='btn-import-template'
        onClick={handleDownloadTemplate}
        shape='circle'
        icon={<FaArrowDown />}
      />
    </Tooltip>
  )
}
